import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons";
import { Alert, Snackbar } from "@mui/material";
import profile, {
  allroles,
  changelang,
  editprofile,
  usertype,
} from "./funtionsBD/Mainservice";
import { useTranslation } from "react-i18next";
import { allclublist } from "./funtionsBD/Mainservice";
import { Registerself } from "./funtionsBD/Authservice";
import moment from "moment";
import "./Register.css";
import { useNavigate } from "react-router-dom";
import { initializeSocket } from "../socket";
import { usePermissions } from "../context/Permissioncontext";

const CompleteForm = () => {
  const [pictures, setPictures] = useState([]);
  const [imgvalue, setimgvalue] = useState();
  const [Type, setType] = useState([]);
  const [Role, setRole] = useState([]);
  const [error, setError] = useState("");

  const [club, setclub] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const lng = localStorage.getItem("lng") || "en";

  const navigate = useNavigate();
  const { loadPermissions } = usePermissions();

  const validate = (values) => {
    const errors = {};

    if (!values.alias) {
      errors.alias = `${t("require")}`;
    } else if (values.alias.length > 100) {
      errors.alias = `${t("must")}`;
    }
    if (!values.height) {
      errors.height = `${t("require")}`;
    }
    if (!values.weight) {
      errors.weight = `${t("require")}`;
    }
    if (!values.bday) {
      errors.bday = `${t("require")}`;

      return errors;
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    gettyp();
    getprofile();
  }, []);

  const gettyp = async () => {
    try {
      const response = await usertype();
      setType(response.data.data.typesUser);
      formik.setFieldValue(
        "type",
        response.data.data.typesUser[2].type_user_id
      );
    } catch (error) {
      console.log(error);
    }
  };
  const getprofile = async () => {
    try {
      const response = await profile();
      const user = response.data.data;
      formik.setValues({
        email: user.user_email,
        clubid: user.club_id,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    setimgvalue(e.target.value);
    setPictures(file);
    formik.setFieldValue("img", URL.createObjectURL(file));
  };

  const handleadd = async (values, { resetForm }) => {
    try {
      const response = await editprofile(pictures, values);
      console.log(response);
      if (response.data.status === "error") {
        console.log(response.data.message);
        setError(response.data.message);
      } else {
        setsuccess(response.data.message);
        setOpen(true);
        resetForm();
        setimgvalue("");
        localStorage.setItem("user", JSON.stringify(response.data.data));
        console.log("datastore");
        const token = localStorage.getItem("token");
        const socket = initializeSocket(token);
        console.log("initialized");

        socket.on("disconnect", () => {});
        console.log("diaconnect");

        loadPermissions(response.data.data.permissions);
        console.log("load");

        console.log(response.data.data.permissions);
        chngelang(response.data.data);
      }
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };
  const chngelang = async (data) => {
    const response2 = await changelang(lng);
    localStorage.setItem("lng", lng);
    localStorage.setItem("i18nextLng", lng);
    if (response2.data.status === "success") {
      // Skip competency block setup and go directly to dashboard
      navigate("/home");
    }
  };

  const formik = useFormik({
    initialValues: {
      alias: "",
      fname: "",
      lname: "",
      email: "",
      clubid: "",
      gender: "male",
      bday: "",
      type: "",
      img: "",
      height: "",
      weight: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      handleadd(values, { resetForm });
    },
  });
  const agelimit = moment(new Date()).format("YYYY-MM-DD");

  console.log("values", formik.values);
  return (
    <>
      <form className="login-form" onSubmit={formik.handleSubmit}>
        <div className="edit-pic">
          {formik.values.img ? (
            <img src={formik.values.img} alt="" />
          ) : (
            <div className="profile_img_icon">
              {formik.values.fname ? formik.values.fname.slice(0, 1) : "+"}
            </div>
          )}
          <label htmlFor="img" className="edit-img-label">
            <FontAwesomeIcon icon={faCameraRetro} className="edit-camera" />
          </label>
        </div>
        <input
          className="input_addpicsvg"
          type="file"
          name="img"
          value={imgvalue}
          id="img"
          accept="image/*"
          onChange={handleFileInputChange}
        />
        <div className="registerinput-details">
          <div className="registerinput-detail">
            <label htmlFor=""> {t("usertype")}</label>
            <select
              value={formik.values.type}
              onChange={formik.handleChange}
              name="type"
            >
              {Type.map((t, index) => (
                <option key={index} value={t.type_user_id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>

          {/* <div className="registerinput-detail">
            <label htmlFor=""> {t("selectclub")}</label>
            <select
              value={formik.values.club_id}
              onChange={formik.handleChange}
              name="club_id"
            >
              {club.map((t, index) => (
                <option key={index} value={t.club_id}>
                  {t.club_name}
                </option>
              ))}
            </select>
          </div> */}
          <div className="registerinput-detail">
            <label htmlFor="">{t("alias")}</label>
            <input
              placeholder={t("writealias")}
              type="text"
              value={formik.values.alias}
              name="alias"
              onChange={formik.handleChange}
            />
          </div>
          <div className="registerinput-detail">
            <label htmlFor="">{t("firstname")}</label>
            <input
              placeholder={t("writename")}
              type="text"
              value={formik.values.fname}
              name="fname"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.fname ? (
            <div className="validation_error">{formik.errors.fname}</div>
          ) : null}

          <div className="registerinput-detail">
            <label htmlFor="">{t("lastname")}</label>
            <input
              placeholder={t("writename")}
              type="text"
              value={formik.values.lname}
              name="lname"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.lname ? (
            <div className="validation_error">{formik.errors.lname}</div>
          ) : null}

          <div className="registerinput-detail">
            <label htmlFor=""> {t("birthdate")}</label>
            <input
              type="date"
              max={agelimit}
              value={formik.values.bday}
              name="bday"
              onChange={(e) => {
                formik.setFieldValue('bday', e.target.value);
              }}
              placeholder="dd/mm/yyyy"
            />{" "}
            {formik.errors.bday ? (
              <div className="validation_error">{formik.errors.bday}</div>
            ) : null}
          </div>

          <div className="registerinput-detail">
            <label htmlFor="">
              {" "}
              {t("weight")}
              (kg)
            </label>
            <input
              placeholder={t("enterweight")}
              type="number"
              name="weight"
              value={formik.values.weight}
              onChange={formik.handleChange}
            />
            {formik.errors.weight ? (
              <div className="validation_error">{formik.errors.weight}</div>
            ) : null}
          </div>

          <div className="registerinput-detail">
            <label htmlFor="">
              {" "}
              {t("height")}
              (cm)
            </label>
            <input
              placeholder={t("enterheight")}
              type="number"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
            />{" "}
            {formik.errors.height ? (
              <div className="validation_error">{formik.errors.height}</div>
            ) : null}
          </div>

          <div className="registerinput-detail">
            <label htmlFor=""> {t("gender")}</label>
            <div className="input-radio-btn">
              <input
                type="radio"
                name="gender"
                value="female"
                checked={formik.values.gender === "female"}
                onChange={formik.handleChange}
              />
              <label htmlFor="female"> {t("female")}</label>
            </div>
            <div className="input-radio-btn">
              <input
                type="radio"
                name="gender"
                value="male"
                checked={formik.values.gender === "male"}
                onChange={formik.handleChange}
              />
              <label htmlFor="male"> {t("male")}</label>
            </div>
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <button className="registerinput-button" type="submit">
          {t("save")}
        </button>

        <Snackbar
          open={open}
          autoHideDuration={3000}
          onClose={closealert}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled" severity="success">
            {success}
          </Alert>
        </Snackbar>
      </form>
    </>
  );
};

export default CompleteForm;
